import { useLocation, useNavigate } from "react-router-dom";
import NavBarWithLogin from "../../components/header/navBarWithLogin";
//import ImageBannerContract from "../../common/assets/Group-7923-1.png";
import { useFetchFamilyComposition } from "../../common/services/sanitas/apiSanitasFamilyComposition";
import DataTable from "../../components/elements/dataTable";
import DataTableMobile from "../../components/elements/dataTableMobile";
import { useEffect, useState } from "react";
import Loading from "../../components/elements/loading";

const ImageBannerContract = "/documents/d/guest/Group-7923-1";

const FamilyComposition = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const payload = location.state?.payload;
  const contractNumber = payload?.card?.contractNumber;
  const code = payload?.card?.familyNumber;
  const [ data, setData ] = useState<string[][]>([]);
  const [mobileData, setMobileData] = useState([]);

  const { data: dataFamilyComposition, error, isLoading } = useFetchFamilyComposition(payload, contractNumber, code, "1", "10");

  const handleBack = () => {
    navigate(-1);
  };

  const columns = [
    { key: 'names', label: 'Registro', tipo: 'text', visible: false },
    { key: 'relationshipName', label: 'Parentesco', tipo: 'text', visible: true, color: true },
    { key: 'familyNumber', label: 'N° Familia', tipo: 'text', visible: true },
    { key: 'insureFrom', label: 'Inicio cobertura', tipo: 'text', visible: true, color: true },
    { key: 'antiquity', label: 'Antigüedad*', tipo: 'text', visible: true },
    { key: 'insureTo', label: 'Vigencia', tipo: 'text', visible: true, color: true },
    { key: 'statusAffiliate', label: 'Estado', tipo: 'status', visible: true },
  ];

  useEffect(() => {
    if (dataFamilyComposition) {
      const transformedData = dataFamilyComposition.map(
        ({
          relationshipName, member, familyNumber, antiguaty, 

        }: {
          relationshipName: string, member: any, familyNumber: string, antiguaty: number
        }) => ({
          names: member.names + ' ' + member.firstSurname + ' ' + member.secondSurname + ' - ' + member.identityDocument,
          relationshipName: relationshipName,
          familyNumber: familyNumber,
          insureFrom: member.insureFrom,
          antiquity: antiguaty,
          insureTo: member.insureFrom + ' - ' + member.insureTo,
          statusAffiliate: member.statusAffiliate === 'V' ? 'Vigente' : 'Inactivo',
        })
      );
      setData(transformedData);

      const transformedMobileData = dataFamilyComposition.map(
        ({ 
          relationshipName, member, antiguaty
        }: { 
          relationshipName: string, member: any, antiguaty: number
        }) => ({
        fullname: member.names + ' - ' + member.identityDocument,
        names: member.names,
        identityDocument: member.identityDocument,
        relationshipName: relationshipName,
        familyNumber: member.familyNumber,
        insureFrom: member.insureFrom,
        antiquity: antiguaty ,
        insureTo: member.insureFrom + ' - ' + member.insureTo,
        statusAffiliate: member.statusAffiliate === 'V' ? 'Vigente' : 'Inactivo',
      }));
      setMobileData(transformedMobileData);
    }
  }, [dataFamilyComposition]);

  useEffect(() => {
    if (error) {
      console.log('Error:', error);
    }
  }, [error]);

  if (isLoading) return <Loading />;

  return (
    <>
    <section className="hero">
      <div className="padding-global">
        <div className="padding-section-small">
          <div className="container-medium">
            <div className="hero_wrp">
              <div className="hero_box is-ajuste">
                <div className="title-component">
                  <h1 className="title">Composición familiar</h1>
                  <div className="line-title"></div>
                </div>
              </div>
              <img
                src={ImageBannerContract}
                loading="lazy"
                alt=""
                className="banner_person"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
    <section className="perfil-t">
      <div className="padding-global">
        <div className="padding-section-medium">
          <div className="container-large">
            <div className="cfamiliar_wrp">
              <DataTable columns={columns} rows={data} />
              <DataTableMobile columns={columns} rows={mobileData} />
              <div>*La antiguedad es en base a los antecedentes previos de ingreso a Sanitas</div>
              <div className="cmedicasfast_btn">
                  <a onClick={handleBack} className="button is-medium is-white w-button">Atrás</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </>
  );
};

export default FamilyComposition;